import script from "./CartSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartSummary.vue?vue&type=script&setup=true&lang=ts"

import "./CartSummary.vue?vue&type=style&index=0&id=3f83bcf2&scoped=true&lang=css"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f83bcf2"]])

export default __exports__